import { ProgressiveBarService } from 'src/app/shared/progressive-bar/progressive-bar.service';
import { DataEntry } from './../../shared/data-entry.interface';
import { Component, OnInit } from '@angular/core';
import { CommonService } from '../common.service';
import { WebcallsService } from 'src/app/webcalls.service';
import { DataproviderService } from 'src/app/dataprovider.service';
import { TooltipTypesEnum } from 'src/app/shared/tooltip-types.enum';
import { Header } from '../header.interface';
import { Subscription } from 'rxjs';

@Component({
  selector: "app-smart-thermo",
  templateUrl: "./smart-thermo.component.html",
  styleUrls: ["./smart-thermo.component.scss", "./smart-thermo.component.responsive.scss"],
  host: {
    class: 'center-route-content d-block p-l-page-thermo p-b-104'
  }
})
export class SmartThermoComponent implements OnInit {
  title: string = "b2c.IDS_SMARTTHERMO";
  subtitle: string = "b2c.IDS_SMARTTHERMO_SUB";
  showSubtitle: boolean = true;
  addon: string = "b2c.IDS_SMARTTHERMO_ADDON";
  showAddon: boolean = true;
  question: string = "b2c.IDS_SMARTTHERMO_QUE";
  activePage: string = "smart-thermo";
  nextPage: string = "";
  eventCategory: string = "IDS_GTAG_CATEGORY";
  eventLabel: string = "IDS_SMARTTHERMO_LABEL_".concat(this.ds.getWhatToDo().name.toString());
  dataEntriesSmartThermo: any[];
  addOnDataEntriesSmartThermo: any[];

  openVideoModal = false;
  videoModalUrl: string = null;
  tooltipType: TooltipTypesEnum = TooltipTypesEnum.DISCOVER;

  header: Header;
  pageSubscriptions: Subscription[] = [];

  showSidebar: boolean = false;

  constructor(
    private cs: CommonService,
    private ws: WebcallsService,
    private ds: DataproviderService,
    private progressiveBarService: ProgressiveBarService
  ) {
    this.setNextPage();
    this.pageSubscriptions.push(
      this.cs.paramsHeaderChanged.subscribe((params: Header) => {
        this.header = params;
      })
    );
    this.cs.setParams(
      this.title,
      this.subtitle,
      this.question,
      this.activePage,
      this.nextPage,
      false,
      true,
      false,
      true,
      null,
      false,
      this.showAddon,
      this.eventCategory,
      this.eventLabel,
      false,
      '',
      true,
      this.showSubtitle,
      false,
      this.addon
    );
    this.progressiveBarService.setProgressiveBarLengthByPageIndex(6);
  }

  ngOnInit() {
    if ((this.ds.getSmartThermo() == undefined) || (this.ds.getSmartThermo().length == 0)){
      this.dataEntriesSmartThermo = [
        { ID: 0, name:"XG8002", description: "b2c.IDS_XG8002_DESCR", image: "../../assets/img/smart-thermo/XG8002.png", tooltip: "", lateralPanelTitle: "b2c.IDS_XG8002_LATERAL-PANEL_TITLE", lateralPanelDescription: "b2c.IDS_XG8002_LATERAL-PANEL_DESCR", videoUrl: "./../assets/video/XG8002.mp4", brand:"BTI", code: "XG8002", price: 0, quantity: 1, included: true, mnemonic:1, itemID:0, systemID:5}
      ]
      this.wsCall();
      this.ds.setSmartThermo(this.dataEntriesSmartThermo);
    }
    else {
      this.dataEntriesSmartThermo = this.ds.getSmartThermo();
    }

    if ((this.ds.getSmartThermoAddon() == undefined) || (this.ds.getSmartThermoAddon().length == 0)){
      this.addOnDataEntriesSmartThermo = this.ds.getDefaultSmartThermoAddon()
      // this.wsCallAddon();
      this.ds.setSmartThermoAddon(this.addOnDataEntriesSmartThermo);
    }
    else {
      this.addOnDataEntriesSmartThermo = this.ds.getSmartThermoAddon();
    }

    this.cs.updateNextBtn(this.canConfirm());
  }

  setNextPage() {
    let whatToDoSelection = this.ds.getWhatToDo();
    if (whatToDoSelection.ID == 3 && this.ds.getBoolHavingBTicino()) {
      this.nextPage = "times";
    } else {
      this.nextPage = "finishing";
    }
    this.cs.updateNextPage(this.nextPage);
  }

  setDataEntries(data: any[]) {

  }

  wsCall() {
    for (let st of this.dataEntriesSmartThermo) {
      this.ws.getPricelistItem(
        this.ds.getLocalizationID(),
        st.brand,
        st.code).subscribe(data => {
          st.price=data["PriceRR"];
          st.itemID=data["ItemID"];
      });
    }
  }

  // wsCallAddon() {
  //   for (let sta of this.addOnDataEntriesSmartThermo) {
  //     this.ws.getPricelistItem(
  //       this.ds.getLocalizationID(),
  //       sta.brand,
  //       sta.code).subscribe(data => {
  //         sta.price=data["PriceRR"];
  //         sta.itemID=data["ItemID"];
  //     });
  //   }
  // }

  canConfirm(){
    let f: boolean = false;
    for (let thermo of this.dataEntriesSmartThermo) {
      if(thermo.quantity > 0){
        f = true;
      }
    }
    return f;
  }

  onIUSpinnerUpd(qta: number, id: number){
    for (let thermo of this.dataEntriesSmartThermo) {
      if(thermo.ID == id){
        thermo.quantity = qta;
      }
    }
    //this.ds.setSmartThermo(this.dataEntries);
    this.cs.updateNextBtn(this.canConfirm());
  }

  onIUSpinnerUpdAddon(qta: number, id: number) {
    for (let thermo of this.addOnDataEntriesSmartThermo) {
      if(thermo.ID == id){
        thermo.quantity = qta;
      }
    }
  }

  // dataEntriesUpdate(idSelected: number) {
  //   /* single selection */
  //   for (let data of this.dataEntries) {
  //     if ( data["ID"] == idSelected ) { data.checked = true; } else { data.checked = false; }
  //   }
  //   this.cs.updateNextBtn(true);
  // }

  // onSelectorClicked(idSelected: number) {
  //   this.dataEntriesUpdate(idSelected);
  //   let flag = this.dataEntries.find(function(iu){
  //     return iu["ID"] == idSelected;
  //   });
  //   this.ds.setAddSmartCamera(flag.ID == 1);
  // }

  onInfoClick(entryId: number) {
    let entry = null;
    for (let i = 0; i < this.dataEntriesSmartThermo.length; i++) {
      entry = this.dataEntriesSmartThermo[i];
      if (entry && entry.ID === entryId) {
        break;
      }
    }

    for (let i = 0; i < this.addOnDataEntriesSmartThermo.length; i++) {
      entry = this.addOnDataEntriesSmartThermo[i];
      if (entry && entry.ID === entryId) {
        break;
      }
    }

    if (entry && entry.videoUrl) {
      this.videoModalUrl = entry.videoUrl;
      this.openVideoModal = true;
    }
  }

  ngOnDestroy() {
    this.pageSubscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }
  getAllComponent(){
    let allComponents = this.dataEntriesSmartThermo.concat(this.addOnDataEntriesSmartThermo);
    return allComponents;
  }

  onCloseTooltip() {
    this.showSidebar = false;
  }
}
